import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DeleteCommunityModal = ({ show, onHide, onConfirm, communityName }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);

    const handleConfirm = async () => {
        setIsDeleting(true);
        setError(null);

        try {
            await onConfirm();
            onHide();
        } catch (err) {
            setError(
                err.response?.data?.message ||
                    'Failed to delete community. Please try again.'
            );
        } finally {
            setIsDeleting(false);
        }
    };

    const handleClose = () => {
        setError(null);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            aria-labelledby="delete-community-modal-title"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title
                    id="delete-community-modal-title"
                    className="text-danger fw-bold"
                >
                    Delete Community
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-3">
                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                    </Alert>
                )}

                <p className="mb-3">
                    Are you sure you want to delete{' '}
                    <strong>{communityName}</strong>?
                </p>
                <p className="text-muted mb-0">
                    This community will be archived and hidden from public view.
                    Posts and member data are preserved but will no longer be
                    accessible on the site. There is no self-service way to
                    restore an archived community.
                </p>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0">
                <Button
                    variant="outline-primary"
                    onClick={handleClose}
                    className="px-4 rounded-pill"
                    disabled={isDeleting}
                >
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={handleConfirm}
                    disabled={isDeleting}
                    className="px-4 rounded-pill"
                >
                    {isDeleting ? 'Deleting...' : 'Delete Community'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

DeleteCommunityModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    communityName: PropTypes.string.isRequired,
};

export default DeleteCommunityModal;
